import { saveInfo } from 'redux/modules/project/saveInfo'
import { closeModal } from './closeModal'

export const save = info => async dispatch => {
  const { projectName, currency, timezone } = info
  await dispatch(saveInfo({ projectName, currency, timezone }))
  dispatch(closeModal())
}
